import React, { Component } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import ship from "../image/ship.webp";

class Return extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <HeaderBar {...this.props} />
        <div className="about-page">
          <div className="about-contain">
            <div className="title"></div>
            <div className="about-tent">
              <div className="left">
                <h1>
                  How do I cancel my order, return an item or ask for a refund?
                </h1>
              </div>
              <div className="right">
                <p>
                  How do I cancel my order, return an item or ask for a refund?
                  ← Buying FAQ When you buy on Folksy, the sales contract is
                  between each individual "seller" and "you", the buyer. Folksy
                  provides a service to facilitate that contract but is not
                  responsible for it or its fulfilment.
                </p>
                <p>
                  Please note: Unless faulty, the following types of items are
                  non-refundable: items that are personalised, bespoke or
                  made-to-order to your specific requirements; items which
                  deteriorate quickly (e.g. food), personal items sold with a
                  hygiene seal (cosmetics, underwear) in instances where the
                  seal is broken.
                </p>
                <p>
                  <b>Cancelling a transaction.</b>
                </p>
                <p>
                  You have the right to cancel your order and return the item to
                  the seller for a full refund, even if the item is not faulty
                  in any way. To do this you must contact the individual seller
                  within 14 days of receiving your item(s) and you must do this
                  in writing. The seller can organise your refund or simply
                  cancel the order if it has not been paid for.
                </p>
                <p>
                  Get in touch with the seller by clicking on the 'Contact' link
                  at the top of their shop page, or send them an email. Their
                  email address is provided both in your confirmation of order
                  email, the notification of shipping email and on your Paypal
                  receipt.
                </p>
                <p>
                  When contacting the seller, please state the order details
                  (date of order, the username/email address you used to order,
                  item name, quantity, price, etc.), or copy and paste the text
                  form blow, fill in the details and email or post it to the
                  seller. All of the information you need to fill in this form
                  is contained in your confirmation of order email*
                </p>
                <p>
                  <b>Return of faulty goods.</b>
                </p>
                <p>
                  You have a right to return goods if they develop a fault up to
                  six months after receipt of the goods. Depending on the
                  circumstances, you may be entitled to a repair, replacement or
                  a full or partial refund. Please contact the seller to inform
                  them of the fault so that they can try to sort the problem out
                  for you.
                </p>
                <p>
                  <b>Lost items.</b>
                </p>
                <p>
                  If the item has been posted but is lost in transit, the seller
                  should provide a refund or re-deliver the same item. Please
                  contact the individual seller to report a lost item.
                </p>
                <p>
                  In the rare event of a shop not delivering the goods please
                  contact them for a refund.
                </p>
                <p>
                  <b>I've emailed the seller but they haven't replied!</b>
                </p>
                <p>
                  If you have not heard from the seller within a few days of
                  contacting them, if you no longer have access to your
                  confirmation of order email, or if you need any other
                  assistance in contacting the seller, please let us know
                  (stating as much details about the order as possible) and
                  we'll do our best to help!{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
        <FooterBar {...this.props} />
      </React.Fragment>
    );
  }
}

export default Return;
